export class SliderConfig {
  sets: boolean;
  center: boolean;
  finite = false;
  autoplay: boolean;
  pauseAutoplay = false;
  velocity = 1;
  interval = 7;
}
